<template>
    <div>
        <el-row style="margin-top: 20px" :gutter="20">
            <template v-for="(item,i) in data.list">
                <el-col :key="i" :span="4">
                    <div  class="itemEvent">

                        <el-dropdown class="item-el-dropdown">
                              <span class="el-dropdown-link">
                                  <template v-if="item.open ==='Y'">
                                        <i class="el-icon-s-opportunity" style="color: rgb(247, 186, 42)"></i>
                                  </template>
                                  <template v-else>
                                       <i class="el-icon-s-opportunity"></i>
                                  </template>
                                  <i class="el-icon-more"></i>
                              </span>
                            <el-dropdown-menu slot="dropdown">
                                <template v-if="item.isAdmin">
                                    <el-tag  class="item-el-dropdown-item" @click="invite(item.id)">授权</el-tag>
                                    <template v-if="item.invites.length > 0">
                                        <el-tag  class="item-el-dropdown-item" @click="showInvites({id:item.id,invites:item.invites})">人员列表</el-tag>
                                    </template>
                                    <el-tag  class="item-el-dropdown-item" @click="setOpen(item.id,item.open)">
                                        {{item.open ==='Y'?"设置为非公共":"设置为公共"}}
                                    </el-tag>
                                </template>
                                <el-tag class="item-el-dropdown-item" @click="saveDataList(item)">修改名称</el-tag>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <div class="itemEvent0" @click="toEventTool(item.id,item.name)">{{item.name}}</div>
                    </div>
                </el-col>
            </template>

            <el-col :span="4">
                <div  class="itemEvent" @click="createData">
                    <div class="itemEvent0"><i class="el-icon-plus" style="font-weight: 800"></i></div>
                </div>
            </el-col>
        </el-row>

        <!--分页-->
        <div class="page">
            <el-pagination
                background
                @current-change="loadData"
                :current-page="params.page"
                layout="total, prev, pager, next, jumper"
                :page-size="data.pageSize"
                :total="data.total">
            </el-pagination>
        </div>

        <el-dialog title="修改名称" :visible.sync="showModal" :close-on-click-modal="false"
                   width="500px">
            <el-form ref="formPatam" :model="formPatam" :rules="formRules" label-width="85px"
                     label-position="right">
                <el-form-item label="名称:" size="small">
                    <el-input v-model="formPatam.name"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showModal = false">取 消</el-button>
                <el-button type="primary" @click="saveDataList(formPatam)">保存</el-button>
            </div>
        </el-dialog>

        <el-dialog title="人员列表" :visible.sync="showModalInvites" :close-on-click-modal="false"
                   width="500px">
            <el-table border style="width: 100%" :data="invites" v-loading="loading">
                <el-table-column label="名称" prop="email"></el-table-column>
                <el-table-column label="操作" width="80px">
                    <template slot-scope="scope">
                        <template>
                            <el-popover
                                placement="top"
                                width="160"
                                v-model="deletevisible">
                                <p>确定移除吗？</p>
                                <div style="text-align: right; margin: 0">
                                    <el-button size="mini" type="text" @click="deletevisible = false">取消</el-button>
                                    <el-button type="primary" size="mini" @click="removeInvite(scope.row.id)">确定
                                    </el-button>
                                </div>
                                <el-button slot="reference">移除</el-button>
                            </el-popover>
                        </template>

                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

    </div>
</template>

<script>
import request from "../../common/request";
import utils from "../../common/utils";
import api from "../../common/api";

export default {
  metaInfo: {
    title: '事件风暴-个人风暴', // set a title
    meta: [{                 // set meta
      name: 'keywords',
      content: '事件风暴,EventStorming,Big Picture,Design Level,DDD,CQRS,ES'
    }, {
      name: 'description',
      content: '事件风暴EventStorming 是一个单一的大型研讨会，涉及我们期望合作解决关键业务问题的所有关键人员。 我们将建立整个业务线的行为模型，突出协作、边界、责任以及相关参与者和利益相关者的不同观点'
    }],
  },
  name: "DataList",
  data: function () {
    return {
      loading: false,
      params: {
        page: 1,
        name: "",
      },
      data: {
        pageSize: 0,
        total: 0,
        list: [
          {
            createdAt: "",
            id: "",
            invites: [],
            isAdmin: false,
            name: "",
            updatedAt: ""
          }
        ],
      },
      showModal: false,
      formPatam: {
        id: '',
        name: '',
      },
      formRules: {
        name: [{ required: true, message: '名称', trigger: 'blur' }],
      },
      showModalInvites: false,
      removeId: '',
      invites: {},
      deletevisible: false
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    //加载数据
    loadData: function (page) {
      let params = Object.assign({}, this.params);
      if (!utils.isEmpty(page)) {
        params.page = page;
      }
      this.loading = true;
      request.post(api.DataList, params).then((data) => {
        this.data = data;
        this.loading = false;
      }).catch(error => {
        this.loading = false;
        this.$message.error(error)
      });

    },
    saveDataList: function (row) {
      if (this.showModal === false) {
        this.formPatam = {
          id: row.id,
          name: row.name,
        };
        this.showModal = true;
        return;
      }
      this.$refs.formPatam.validate((valid) => {
        if (!valid) return;

        request.post(api.DataListUpdate, this.formPatam).then(() => {
          this.showModal = false;
          this.$message.success("成功")
          this.loadData()
        }).catch(error => {
          this.$message.error(error)
        });
      });
    },
    toEventTool: function (id, name) {
      //新窗口打开
      let routeData = this.$router.resolve({
        name: 'EventTool',
        params: { id: id, name: name },
      })
      window.open(routeData.href, '_blank');

      // this.$router.push({name: 'EventTool', params: {id: id}, query: {name: name}})
    },
    invite(id) {
      this.$prompt('请输入授权人邮箱地址', '授权访问', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: '邮箱格式不正确'
      }).then(({ value }) => {
        request.post(api.DataListInvite, {
          id: id,
          email: value,
        }).then(() => {
          this.$message.success("授权成功")
          this.loadData()
        }).catch(error => {
          this.$message.error(error)
        });
      }).catch(() => {

      });
    },
    createData() {
      this.$prompt('创建事件风暴', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: "请输入事件风暴名称",
        inputValidator: function (value) {
          if (utils.isEmpty(value)) {
            return "请输入事件风暴名称"
          }
          return true
        },
        inputErrorMessage: '名称不正确'
      }).then(({ value }) => {
        request.post(api.DataListSave, {
          name: value,
        }).then(() => {
          this.$message.success("成功")
          this.loadData()
        }).catch(error => {
          this.$message.error(error)
        });
      }).catch(() => {

      });
    },
    showInvites(inviteInfo) {
      this.removeId = inviteInfo.id
      this.invites = inviteInfo.invites
      this.showModalInvites = true
    },
    removeInvite(userId) {
      this.deletevisible = false
      request.post(api.DataListRemoveInvite, {
        id: this.removeId,
        userId: userId,
      }).then(() => {
        this.showModalInvites = false
        this.$message.success("移除成功")
        this.loadData()
      }).catch(error => {
        this.$message.error(error)
      });
    },
    //公共设置
    setOpen(id, open) {
      request.post(api.DataListSetOpen, {
        id: id,
        open: open === "Y" ? "N" : "Y",
      }).then(() => {
        this.$message.success("设置成功")
        this.loadData()
      }).catch(error => {
        this.$message.error(error)
      });
    },
  }
}
</script>

<style scoped>
</style>
